import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  withStyles,
  Typography,
  Grid,
  Tooltip,
  LinearProgress
} from '@material-ui/core'
import { Field } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import VerifiedUser from '@material-ui/icons/VerifiedUser'
import { Snackbar } from 'elentari'
import TextField from '../../../components/TextField'
import DatePicker from '../../../components/DatePicker'
import {
  parseTelefone,
  parseRg,
  parseCpf,
  parseCep
} from '../../../utils/Parse'
import UploadField from '../../../components/UploadField'
import motoristaRepository from './MotoristaRepository'
import CustomFileViewer from '../../../components/CustomFileViewer'
import DropzoneField from '../../../components/DropzoneField'
import * as yup from 'yup'
import yupValidation from '../../../lib/yupValidation'
import * as R from 'ramda'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import RefreshIcon from '@material-ui/icons/Refresh'
import ObservacaoField from '../../../components/ObservacaoField'
import { formatMotorista } from '../utils/formatMotorista'
import TermoEPoliticaCard from '../../Solicitacoes/Requisicoes/TermoEPolitica/TermoEPoliticaCard'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  importadoKMM: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2)
  },
  title: {
    marginTop: theme.spacing(5)
  },
  progress: {
    marginLeft: theme.spacing(5),
    width: '100%'
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1
  }
})

const motoristaSchema = yup.object().shape({
  motorista: yup.object().shape({
    cpf: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    nome: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    sexo: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cep: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    estado: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cidade: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    bairro: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    logradouro: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    numero: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    naturalidade: yup
      .string()
      .trim()
      .nullable(true),
    naturalidadeUf: yup
      .string()
      .trim()
      .nullable(true),
    dataNascimento: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    rg: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    rgEmissor: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    rgData: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    pisPasep: yup
      .string()
      .trim()
      .nullable(true),
    cnhNumero: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cnhEmissao: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cnhPrimeiraEmissao: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cnhValidade: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cnhCategoria: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cnhEmissor: yup
      .string()
      .trim()
      .nullable(true),
    cnhUf: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cnhRenach: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    cnhImage: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    foto: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    nomeMae: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório'),
    telefone: yup
      .string()
      .trim()
      .nullable(true)
      .required('Obrigatório')
  })
})

export const validateMotorista = yupValidation(motoristaSchema)

function MotoristaForm({
  classes,
  values,
  form,
  showError,
  cannotUpdate,
  ...props
}) {
  const [motoristaFormState, setMotoristaFormState] = useState({
    state: '',
    message: ''
  })
  const [fetching, setFetching] = useState(false)
  const [alreadyFetched, setAlreadyFetched] = useState(false)
  const { id } = useParams()
  const isNew = /new/.test(id)

  const handleChangeCpf = async () => {
    const cpfFormated = values.motorista && values.motorista.cpf
    const cpf = cpfFormated && cpfFormated.replace(/[^\d]/g, '')
    if (cpf && cpf.length === 11 && !alreadyFetched) {
      setAlreadyFetched(true)
      setFetching(true)
      setMotoristaFormState({
        state: 'fetching',
        message: 'Buscando motorista'
      })
      const response = await motoristaRepository.motoristaKmm(cpf)
      if (response.ok) {
        const motorista = formatMotorista(response.data, values)
        const veiculos = response.data.veiculos
        if (veiculos.length > 0) {
          form.change(`veiculos`, veiculos)
        }
        form.change(`motorista`, motorista)
        setMotoristaFormState({
          state: 'success',
          message:
            'Motorista encontrado com sucesso! Alterações devem ser feitas no KMM.'
        })
      } else {
        const motorista = {
          cpf: cpfFormated,
          importadoKMM: false,
          cnhImage: values.motorista.cnhImage,
          foto: values.motorista.foto
        }
        form.change('motorista', motorista)
        setMotoristaFormState({
          state: 'error',
          message: R.pathOr(
            'Falha de conexão com o servidor',
            ['data', 'error', 'message'],
            response
          )
        })
      }
      setFetching(false)
    } else {
      setAlreadyFetched(false)
    }
  }

  const handleChangeImage = name => filePath => {
    form.change(`motorista.${name}`, filePath)
  }

  const importadoKMM = values.motorista?.importadoKMM
  return (
    <>
      {fetching && <LinearProgress />}
      <div className={classes.root}>
        <Grid container spacing={4} justifyContent="center">
          {/* Motorista */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom display="inline">
              Motorista
              {importadoKMM && (
                <Tooltip title="Usuário importado KMM">
                  <VerifiedUser
                    color="disabled"
                    fontSize="small"
                    className={classes.importadoKMM}
                  />
                </Tooltip>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="CPF"
                  parse={parseCpf}
                  name="motorista.cpf"
                  disabled={
                    fetching || cannotUpdate || !isNew || values.renovado
                  }
                  showError={showError}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          disabled={cannotUpdate}
                          onClick={handleChangeCpf}
                        >
                          <RefreshIcon />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <OnChange name="motorista.cpf">{handleChangeCpf}</OnChange>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Nome"
                  name="motorista.nome"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  parse={parseRg}
                  label="RG"
                  name="motorista.rg"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Emissor"
                  name="motorista.rgEmissor"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="Data Emissão"
                  name="motorista.rgData"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                  disableFuture
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Sexo"
                  name="motorista.sexo"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Estado Civil"
                  name="motorista.estadoCivil"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="Data nascimento"
                  name="motorista.dataNascimento"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Naturalidade"
                  name="motorista.naturalidade"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="UF"
                  name="motorista.naturalidadeUf"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="PIS/PASEP"
                  name="motorista.pisPasep"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  parse={parseCpf}
                  label="CPF Mãe"
                  name="motorista.cpfMae"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Nome Mãe"
                  name="motorista.nomeMae"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={TextField}
                  parse={parseCpf}
                  label="CPF Pai"
                  name="motorista.cpfPai"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Nome Pai"
                  name="motorista.nomePai"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              {isNew ? (
                <Grid item xs={12} sm={12} lg={4}>
                  <Field
                    accept=".jpg,.jpeg,.png"
                    label="Foto do Rosto"
                    name="motorista.foto"
                    component={UploadField}
                    disabled={fetching}
                    onFileChange={handleChangeImage('foto')}
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  {!cannotUpdate && (
                    <Grid item xs={12} sm={12} lg={4}>
                      <Field
                        solicitacaoId={values.id}
                        accept=".jpg,.jpeg,.png,.pdf"
                        component={DropzoneField}
                        label="Foto do Rosto"
                        name="motorista.foto"
                        onFileChange={handleChangeImage('foto')}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} lg={4}>
                    <CustomFileViewer
                      newTab
                      label="Foto do Rosto"
                      filePath={values.motorista?.foto}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          {/* CNH */}
          {values.motorista && (
            <Grid item xs={12}>
              <TermoEPoliticaCard
                cpf={values.motorista.cpf}
                embarcador
              ></TermoEPoliticaCard>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography className={classes.title} variant="h6" gutterBottom>
              CNH
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12}>
                <Grid container spacing={4} alignItems="center">
                  {isNew ? (
                    <Grid item xs={12} sm={12} lg={4}>
                      <Field
                        accept=".jpg,.jpeg,.png,.pdf"
                        label="CNH"
                        name="motorista.cnhImage"
                        component={UploadField}
                        disabled={fetching}
                        onFileChange={handleChangeImage('cnhImage')}
                        showError={showError}
                      />
                    </Grid>
                  ) : (
                    <>
                      {!cannotUpdate && (
                        <Grid item xs={12} sm={12} lg={4}>
                          <Field
                            solicitacaoId={values.id}
                            accept=".jpg,.jpeg,.png,.pdf"
                            component={DropzoneField}
                            label="CNH"
                            name="motorista.cnhImage"
                            onFileChange={handleChangeImage('cnhImage')}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} lg={4}>
                        <CustomFileViewer
                          newTab
                          label="CNH"
                          filePath={values.motorista?.cnhImage}
                          fileType="pdf"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Número"
                  name="motorista.cnhNumero"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Renach"
                  name="motorista.cnhRenach"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Emissor"
                  name="motorista.cnhEmissor"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={1}>
                <Field
                  fullWidth
                  component={TextField}
                  label="UF"
                  name="motorista.cnhUf"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={1}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Categoria"
                  name="motorista.cnhCategoria"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="Primeira Emissão"
                  name="motorista.cnhPrimeiraEmissao"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="Data Emissão"
                  name="motorista.cnhEmissao"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Field
                  fullWidth
                  component={DatePicker}
                  label="Validade"
                  name="motorista.cnhValidade"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Endereço */}
          <Grid item xs={12}>
            <Typography className={classes.title} variant="h6" gutterBottom>
              Endereço
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  component={TextField}
                  parse={parseCep}
                  label="CEP"
                  name="motorista.cep"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Estado"
                  name="motorista.estado"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Cidade"
                  name="motorista.cidade"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Bairro"
                  name="motorista.bairro"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Logradouro"
                  name="motorista.logradouro"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Número"
                  name="motorista.numero"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  component={TextField}
                  label="Complemento"
                  name="motorista.complemento"
                  disabled={fetching || importadoKMM || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              {isNew ? (
                <Grid item xs={12} sm={12} lg={4}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    label="Comprovante de Endereço"
                    name="motorista.comprovanteEndereco"
                    component={UploadField}
                    disabled={fetching}
                    onFileChange={handleChangeImage('comprovanteEndereco')}
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  {!cannotUpdate && (
                    <Grid item xs={12} sm={12} lg={4}>
                      <Field
                        solicitacaoId={values.id}
                        accept=".jpg,.jpeg,.png,.pdf"
                        component={DropzoneField}
                        label="Comprovante de Endereco"
                        name="motorista.comprovanteEndereco"
                        onFileChange={handleChangeImage('comprovanteEndereco')}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} lg={4}>
                    <CustomFileViewer
                      newTab
                      label="Comprovante de Endereço"
                      filePath={values.motorista?.comprovanteEndereco}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          {/* Contato */}
          <Grid item xs={12}>
            <Typography className={classes.title} variant="h6" gutterBottom>
              Contato
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} sm={6}>
                <Field
                  fullWidth
                  component={TextField}
                  parse={parseTelefone}
                  label="Telefone"
                  name="motorista.telefone"
                  disabled={fetching || cannotUpdate}
                  showError={showError}
                />
              </Grid>
              <ObservacaoField
                value={values.observacaoContatoMotorista}
                title="Observações do Contato com Motorista"
                placeholder="Escreva aqui observações sobre as informações do contato com o motorista"
                name="novaObservacaoContatoMotorista"
                disabled={cannotUpdate}
              />
            </Grid>
          </Grid>
          {/* Observacao */}
          <ObservacaoField
            value={values.observacaoMotorista}
            title="Observações Motorista"
            placeholder="Escreva aqui observações sobre as informações do motorista"
            name="novaObservacaoMotorista"
            disabled={cannotUpdate}
          />
        </Grid>
        <Snackbar
          message={motoristaFormState.message}
          onClose={() =>
            setMotoristaFormState({ ...motoristaFormState, message: '' })
          }
        />
      </div>
    </>
  )
}

export default withStyles(styles)(MotoristaForm)
